import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

import { Constants } from '@models/constants';

@Pipe({
  standalone: true,
  name: 'customDateFormat',
})
export class CustomDateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any): any {
    const date = (value ?? '').split('T');
    return super.transform(date[0], Constants.DATE_SPECIAL_FMT);
  }
}
